import PageHead from "@/components/PageHead";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BookOpen } from "lucide-react";
import { glossary } from "@/data/schoolsGlossary";

export default function Glossary() {
  return (
    <>
      <PageHead
        title="Glossary | WeKIT Education Intelligence™"
        description="Definitions and formulas behind every KPI and index on the executive dashboard."
        path="/schools/glossary"
      />
      <div className="container max-w-4xl py-8 space-y-8">
        <header>
          <div className="schools-eyebrow flex items-center gap-2 mb-2">
            <BookOpen className="w-3.5 h-3.5" /> Reference · KPI Glossary
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">
            What the numbers mean
          </h1>
          <p className="text-muted-foreground mt-2 max-w-2xl">
            Every KPI in WeKIT Education Intelligence™ is defined, benchmarked, and recalibrated on a
            transparent cadence. Use this glossary during board reviews and parent conversations.
          </p>
        </header>

        <div className="grid gap-4">
          {glossary.map((g) => (
            <Card key={g.key} id={g.key} className="scroll-mt-24">
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between gap-3">
                  <CardTitle className="text-lg">{g.name}</CardTitle>
                  {g.scale && (
                    <Badge variant="secondary" className="rounded-full text-[10px] uppercase tracking-wider shrink-0">
                      {g.scale}
                    </Badge>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">{g.short}</p>
              </CardHeader>
              <CardContent className="space-y-3">
                <p className="text-sm">{g.definition}</p>
                {g.formula && (
                  <div>
                    <div className="schools-eyebrow mb-1">Formula</div>
                    <pre className="text-xs bg-muted rounded-lg p-3 overflow-x-auto font-mono">{g.formula}</pre>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
}
